import CustomCard from "../../../common/CustomCard";

function NotificationCard({ metadata }) {
    return (
        <>
            {
                metadata?.length > 0 && metadata?.map((data) => {
                    return (
                        <div className="dcl-card dcl-notification-card">
                            <CustomCard>
                                <div className="row">
                                    <div className="col-4">
                                        <h6>NAME:</h6>
                                        <h6>{data?.name?.toUpperCase()}</h6>
                                    </div>
                                    <div className="col-4">
                                        <h6>USER ID:</h6>
                                        <h6>{data?.usersID}</h6>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <h6>NOTIFICATION TYPE:</h6>
                                        <h6>{data?.type?.toUpperCase()}</h6>
                                    </div>

                                    <div className="col-12">
                                        <h6>MESSAGE:</h6>
                                        <h6>{data?.message}</h6>
                                    </div>

                                    <div className="col-12">
                                        <h6>AI PROMPT:</h6>
                                        <pre>
                                            {data?.context}
                                        </pre>
                                    </div>

                                </div>

                            </CustomCard>
                        </div>
                    )
                })
            }
        </>

    );
}

export default NotificationCard;